function blogPathTranslator(languageSlug) {
  let blogUriRoot

  switch (languageSlug) {
    case `de_de`:
      blogUriRoot = `bloggen`
      break
    case `zh_cn`:
      blogUriRoot = `博客`
      break
    case `en_us`:
    case `en_gb`:
    case `fr_fr`:
    case `pl_pl`:
    default:
      blogUriRoot = `blog`
      break
  }

  return blogUriRoot
}

module.exports.blogPathTranslator = blogPathTranslator
